import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FiShoppingBag } from "react-icons/fi";
import "../css/header.scss";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="top-bar">
        <div className="top-bar-left">
          <a href="mailto:model@baplehollow.online">
            model@baplehollow.online
          </a>
        </div>
        <div className="top-bar-right">
          <Link to="/cartpage" className="cart-link">
            <FiShoppingBag /> {cartItems ? cartItems.length : 0}
          </Link>
        </div>
      </div>

      <div className="main-header">
        <div className="logo-container">
          <Link to="/" className="logo" onClick={toTop}>
            <img src="/head/baplehollow-logo.svg" alt="baplehollow" />
          </Link>
        </div>

        <div className="nav-and-search">
          <nav className="main-nav">
            <ul>
              <li>
                <Link to="/shop">NEW</Link>
              </li>

              <li>
                <Link to="/about">ABOUT US</Link>
              </li>
              <li>
                <Link to="/contact">HELP CENTER</Link>
              </li>
              <li className="more-menu">
                <details>
                  <summary>MORE</summary>
                  <div className="more-dropdown">
                    <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
                    <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
                    <Link to="/faqs" onClick={toTop}>FAQs</Link>
                    <Link to="/shipping" onClick={toTop}>Shipping</Link>
                    <Link to="/returns" onClick={toTop}>Returns</Link>
                    <Link to="/terms" onClick={toTop}>Terms</Link>
                  </div>
                </details>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
